import { HttpClient } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { environment } from '../../../../environments/environment';


@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss']
})
export class FooterComponent implements OnInit {

 urlPrivacy = 'src/assets/staticfiles/informativa_privacy.pdf';

  constructor(
    private http: HttpClient,
  ) { }

  ngOnInit() {
  }
}
